// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/number.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/number.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo apunte-digital-app
//     node fleet/fleet.ts check --repo apunte-digital-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
export const COMPACT_THRESHOLD = 1000;

/**
 * Formats a number to a compact string (e.g., 1500 -> 1.5k, 1250000 -> 1.3M)
 * using the native Intl.NumberFormat API.
 *
 * @param value The number to format
 * @param locale Optional locale for localized formatting (defaults to 'es')
 * @returns Formatted compact string
 */
export function formatCompactNumber(value: number, locale = "es"): string {
  if (value < COMPACT_THRESHOLD) {
    return value.toString();
  }

  return new Intl.NumberFormat(locale, {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  }).format(value);
}
